'use strict';

import angular from "angular";

import "angular-route";

import "./priv-key";

import "../../common/Api";
import "../../common/Token";


export default angular.module('Login',[
	'Token',
	'ngRoute',
	'fastx.Api',
	'PrivKey'
])
.factory('Login',['$window','Token','$location','Api','PrivKey',function($window,Token,$location,Api,PrivKey){
	var login = {};
	login.getEnv = function(success,error){
		Api.get('api/login/env',{},success,error);
	}
	login.login = function(o,success,error){
		Api.post('api/login',{},o,success,error);
	}
	login.logout = function(success,error){
		$window.localStorage.removeItem('username');
		$window.localStorage.removeItem('host');
		for(var i in $location.$$search){
			$location.search(i,null);
		}
		Api.post('api/logout',{},{},success,error);
		Token.remove();
	}
	login.keyboardInteractive = function(answer,token, success,error){
		Api.post('api/login/keyboard-interactive',{},{answer:answer},success,error);
	}
	login.password = function(password,token,success,error){
		Api.post('api/login/password',{},{password:password},success,error);
	};
	login.publicKey = function(publicKey,token,success,error){
		Api.post('api/login/public-key',{},{publicKey:publicKey},success,error);
	};
	login.publicKeySigned = function(signed,token,success,error){
		Api.post('api/login/public-key/signed',{},{signature:signed},success,error);
	}
	return login;
}]);



//////////////////
// WEBPACK FOOTER
// ./auth/login.js
// module id = 13
// module chunks = 0